<div (click)="toggleList()"
  [ngClass]="{'views-reactions': isListExpanded}">
  <div class="views-reactions-list">
    <li class="d-flex justify-content-center px-2 pt-1">
      <button type="button" class="text-center fnt-size15px btn-desing outline small p-1 px-3 btn btn-light">
        <span class = "secondary-paragraph-bold">
          {{isListExpanded ? viewLessText : viewDetailText}}
        </span>
        <img class="d-inline" [src]="!isListExpanded ? 'assets/images/up-arrow.svg' : 'assets/images/down-arrow.svg'"
          alt="up" width="14" height="14" style="width: 14px;">
      </button>
    </li>
    <li class="d-flex align-items-center justify-content-between w-100 px-2 py-1">
      <p class="text-white paragraph" *ngIf="viewCount">
        <img class="d-inline mb-1" src="assets/images/eye.svg" alt="eye" width="24" height="24" style="width: 24px;">
        {{viewCount}} {{ViewsText}}
      </p>
      <p class="text-white paragraph ml-3" *ngIf="reactionCount">
        <img class="d-inline mb-1" src="assets/images/emoji-mixture.svg" alt="clap" width="47" height="20"
          style="width: 47px;">
        {{reactionCount}} {{ReactionsText}}
      </p>
    </li>
    <div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="10"
    (scrolled)="onScroll()" [scrollWindow]="false" class="overflow-view-list">
    <ul *ngIf="isListExpanded && viewCard.length > 0">
      <li *ngFor="let list of viewCard;trackBy:trackByFn;let i = index"
      class="p-2 d-flex justify-content-between align-items-center w-100"  [ngClass]="{'border-bottom': i != viewCard.length-1  }">
      <div class="d-flex align-items-center">
        <div class="d-flex justify-content-center align-items-center box-40 rounded-circle bg-grey">
          <img *ngIf="list.fileCode" class="box-40 rounded-circle" [src]="list.fileCode" alt="pic"
            onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'">
          <img *ngIf="!list.fileCode" class="box-40 rounded-circle" src="assets/themes/icons/user-profile-placeholder.svg" alt="pic">
        </div>
        <div class="ml-3">
          <p class="text-white paragraph">
            {{list.fullName}}
          </p>
        </div>
      </div>
      <div>
        <span class="ml-3" *ngIf="list.reactionType">
          <img class="d-inline" [src]="getSrc(list.reactionType)" alt="clap" style="width: 26px;">
        </span>
      </div>
    </li>
    </ul>
    <ul *ngIf="isListExpanded && viewCard.length === 0 && viewCount > 0">
      <li *ngFor="let item of [].constructor(flickerValue); let i = index"
      class="border-bottom p-2 d-flex  align-items-center w-100">
      <div class="d-flex justify-content-center align-items-center box-40 rounded-circle bg-grey">
      </div>
        <span class="text1 ml-2"></span>
    </li>
    </ul>
    </div>
  </div>
</div>
